import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';
import { MediaQuery } from '../../media-query';
import moment from 'moment';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        const attrs = { ...props }; // html attributes, without any weird routeTo etc

        if (!MediaQuery.isMobile()) {
            this.setState({
                name: attrs.name,
                action: attrs['data-action'],
                month: null,
                day: null,
                year: null,
                change: attrs.onChange,
            });

            delete attrs.max;
            delete attrs.min;
            delete attrs.type;
            delete attrs.name;
            delete attrs['data-action'];
            delete attrs.onChange;
        }

        this.setState({ attrs: attrs });
    }

    render() {
        if (MediaQuery.isMobile()) {
            return (
                <form-birthdate>
                    <input {...this.state.attrs} />
                </form-birthdate>
            );
        }

        return (
            <form-birthdate>
                <div class='select-month'>
                    {this.renderMonthSelect()}
                </div>
                <div class='select-day'>
                    {this.renderDaySelect()}
                </div>
                <div class='select-year'>
                    {this.renderYearSelect()}
                </div>
                {this.renderHiddenInput()}
            </form-birthdate>
        );
    }

    renderMonthSelect = () => {
        return (
            <select
              {...this.state.attrs}
              data-action={`${this.state.action}-Month`}
              onChange={(e) => this.setMonth(e)}
            >
                <option>Month</option>
                {this.renderMonthOptions()}
            </select>
        );
    }

    renderMonthOptions = () => {
        return [0,1,2,3,4,5,6,7,8,9,10,11].map(m => {
            const month = m + 1;

            return (
                <option
                  value={month.toString().padStart(2, 0)}
                  selected={this.state.month == month}
                >
                    {moment().month(m).format('MMMM')}
                </option>
            );
        });
    }

    setMonth = (e) => {
        this.setState({
            month: e.target.value,
            day: null,
        });
    }

    renderDaySelect = () => {
        return (
            <select
              {...this.state.attrs}
              data-action={`${this.state.action}-Day`}
              onChange={(e) => this.setDay(e)}
              disabled={!this.state.month}
            >
                <option>Day</option>
                {this.renderDayOptions()}
            </select>
        );
    }

    renderDayOptions = () => {
        if (this.state.month) {
            const year = this.state.year || moment().year();
            const days = moment(`${year}-${this.state.month}`, 'YYYY-MM').daysInMonth();

            let daysArray = [];
            for (let i = 1; i <= days; i++) {
                daysArray.push(i);
            }

            return daysArray.map(day => {
                return (
                    <option
                      value={day.toString().padStart(2, 0)}
                      selected={this.state.day == day}
                    >
                        {day}
                    </option>
                );
            });
        }

        return null;
    }

    setDay = (e) => {
        this.setState({
            day: e.target.value,
        });
    }

    renderYearSelect = () => {
        return (
            <select
              {...this.state.attrs}
              data-action={`${this.state.action}-Year`}
              onChange={(e) => this.setYear(e)}
            >
                <option>Year</option>
                {this.renderYearOptions()}
            </select>
        );
    }

    renderYearOptions = () => {
        let yearsArray = [];
        for (let i = moment().year(); i > 1904; i--) {
            yearsArray.push(i);
        }

        return yearsArray.map(year => {
            return (
                <option
                  value={year}
                  selected={this.state.year == year}
                >
                    {year}
                </option>
            );
        });
    }

    setYear = (e) => {
        this.setState({
            year: e.target.value,
        });
    }

    renderHiddenInput = () => {
        const value = (this.state.year && this.state.month && this.state.day)
            ? `${this.state.year}-${this.state.month}-${this.state.day}`
            : null;

        this.state.change({
            target: {
                name: 'birth_date',
                type: null,
                value: value,
            },
        });


        return (
            <input
              type='hidden'
              name={this.state.name}
              value={value}
            />
        );
    }
}

export default connect()(Component);



// WEBPACK FOOTER //
// ./app/components/form/birthdate.js